export var isWindow = typeof window !== "undefined";
